<script setup lang="ts">
import { ProductOverviewList } from "~/templates/partials/navigation/ProductOverviewList";
import { ProductTeaser } from "~/templates/partials/navigation/ProductTeaser";

export interface ProductOverviewListProps {
  level: {
    image?: object;
    teaserLink: {
      label: string;
      link: string;
      type: string;
    };
    teaserHeadline: string;
    teaserSubline: string;
  };
}

const { level } = defineProps<ProductOverviewListProps>();
</script>

<template>
  <div class="flex flex-col gap-8 xl:flex-row">
    <div class="xl:w-9/12">
      <ProductOverviewList :level="level" />
    </div>
    <div v-if="level.teaserHeadline" class="xl:w-3/12">
      <ProductTeaser
        :heading="level.teaserHeadline"
        :subline="level.teaserSubline"
        :link="level.teaserLink"
        :image="level.image"
      />
    </div>
  </div>
</template>
